import constants from '../../constants';

export default angular.module('FrontRoyal.Oreo', []).constant(constants);
